module.exports = __webpack_public_path__ + "./img/table_display_filter_icon_white.svg";